import { productRecentlyViewedReducer } from '../../productRecentlyViewed/reducers/ProductRecentlyViewedReducer';
import productRecentlyViewedSaga from '../../productRecentlyViewed/sagas/ProductRecentlyViewedSaga';
import deliveryPromiseSaga from '../../deliveryPromise/sagas/DeliveryPromiseSaga';
const loadProductRecentlyViewedModule = () => ({
    id: 'ProductRecentlyViewed',
    reducerMap: {
        productRecentlyViewed: productRecentlyViewedReducer,
    },
    sagas: [productRecentlyViewedSaga, deliveryPromiseSaga],
});
export default loadProductRecentlyViewedModule;
